import React, { useEffect, useState } from "react";
import { Trophy, X, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAccess } from "@/context/AccessContext";

const fmt = (s) => {
  if (s <= 0) return "drawing now";
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  return d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${String(s % 60).padStart(2, "0")}s`;
};

export function JackpotBanner() {
  const { active } = useAccess();
  const [jp, setJp] = useState(null);
  const [next, setNext] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("pb_jackpot_banner_dismissed") === "1");
  const [, tick] = useState(0);

  useEffect(() => {
    api.get("/jackpot").then((r) => setJp(r.data)).catch(() => {});
    api.get("/draws/schedule?count=1").then((r) => setNext(r.data.upcoming[0])).catch(() => {});
    const t = setInterval(() => tick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, []);

  if (!jp?.big || hidden) return null;
  const secs = next ? Math.max(0, Math.floor((new Date(next.draw_time_iso) - Date.now()) / 1000)) : null;

  const go = () => {
    document.getElementById("oracle")?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (active) setTimeout(() => window.dispatchEvent(new Event("pb:generate")), 500);
  };

  return (
    <div data-testid="jackpot-banner" className="relative overflow-hidden bg-oracle text-ink">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_left,rgba(255,255,255,0.35),transparent_60%)] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-2.5 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
        <div className="flex items-center gap-3 font-body text-sm">
          <Trophy className="w-4 h-4 shrink-0" strokeWidth={2} />
          <span data-testid="jackpot-banner-text">
            <span className="font-heading text-xl sm:text-2xl leading-none mr-2">{jp.jackpot_text}</span>{" "}jackpot on the line
            {secs !== null && <> · draws in <span data-testid="jackpot-banner-countdown" className="font-semibold tabular-nums">{fmt(secs)}</span></>}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button data-testid="jackpot-generate-btn" onClick={go} size="sm" className="bg-ink text-oracle hover:bg-black label-caps h-8">
            <Sparkles className="w-3.5 h-3.5 mr-2" strokeWidth={2} /> {active ? "Generate pick" : "Unlock & pick"}
          </Button>
          <button data-testid="jackpot-banner-dismiss" aria-label="Dismiss" onClick={() => { sessionStorage.setItem("pb_jackpot_banner_dismissed", "1"); setHidden(true); }} className="p-1.5 rounded hover:bg-black/10 transition-colors">
            <X className="w-4 h-4" strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
}
